import React from "react";
import { Form, Select } from "antd";
import { getFieldByVal } from "Pages/FacultiesAntd/Regions/FacultiesRegionsFilter";
interface FacultiesBranchesFilterIF {
  filterState: any;
  setFilterState: any;
  subjects: any;
}
const FacultiesBranchesFilter = ({
  filterState,
  setFilterState,
  subjects,
}: FacultiesBranchesFilterIF) => {
  const handleAddFilterArrayList = (name: string, val: any) => {
    setFilterState((prevState: any) => ({
      ...prevState,
      [name]: val,
      chipFields: {
        ...prevState,
        [name]: val,
      },
    }));
  };
  return (
    <Form layout={"vertical"} className="w-100">
      <Form.Item label="Subjects">
        <Select
          showSearch
          placeholder="subject"
          value={filterState.subject}
          style={{ width: "100%" }}
          size="large"
          allowClear
          options={subjects}
          onChange={(selected: any) => {
            handleAddFilterArrayList(
              "subject",
              getFieldByVal(subjects, selected)
            );
          }}
        />
      </Form.Item>
    </Form>
  );
};

export default FacultiesBranchesFilter;
